module.exports = __webpack_public_path__ + "img/Icon - Wireless.a2330973.png";